<template>

<div class="results">

    <div class="results-empty" v-if="!results.length">{{ page.results_empty }}</div>

    <com-item v-for="result in results" :key="result.id" :item="result" />

</div>

</template>

<script>

import comItem from './results/Item'

export default {

    props: ['results'],

    components: {
        'com-item': comItem
    }

}

</script>

<style scoped>

.results {
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    flex-direction: column;
    margin: 20px 0px;
}

.results-empty {
    padding: 60px 20px;
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
    text-align: center;
    color: var(--color-grey-dark);
    font-size: 16px;
    font-weight: 300;
}

</style>
